import { publicApiUrl } from 'App/utils';
import { RemindersApiClient, TaskSdkModule } from './types';

const { Configuration, RemindersApi } = require( '@emilgroup/task-sdk' ) as TaskSdkModule;

export const createRemindersApi = (): RemindersApiClient => {
  return new RemindersApi( new Configuration(), publicApiUrl ?? '' );
};
